import { useState } from "react";

export default function Query() {
  const [query, setQuery] = useState("SELECT * FROM users limit 1");
  const [results, setResults] = useState("");

  async function submitQuery() {
    // post to /sql_queries
    const res = await fetch("http://localhost:3000/dev/sql_queries", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query }),
    });
    return res.json();
  }

  function getResults() {
    submitQuery().then(setResults);
  }

  return (
    <div>
      <h1>Query</h1>
      <p>Enter the SQL statement to query the database</p>
      <textarea value={query} onChange={(e) => setQuery(e.target.value)} />
      <button onClick={() => getResults()}>Search</button>
      <p>Query result: {JSON.stringify(results)}</p>
    </div>
  );
}
